
import { cn } from '@/lib/utils';
import { choiceSelectedSurface, choiceTrackSurface, choiceUnselectedOnTrackSurface } from './formFieldStyles';

export interface SegmentOption {
  value: string;
  label: string;
}

export interface SegmentedControlProps {
  name: string;
  label?: string;
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
  /** Stack options vertically on small screens (long labels). */
  stackOnMobile?: boolean;
  className?: string;
}

export function SegmentedControl({
  name,
  label,
  options,
  value,
  onChange,
  stackOnMobile = false,
  className,
}: SegmentedControlProps) {
  return (
    <div className={cn('w-full', className)} role="radiogroup" aria-label={label}>
      {label && (
        <span className="block text-sm text-slate-600 dark:text-slate-400 mb-2">{label}</span>
      )}
      <div
        className={cn(
          'rounded-full p-1 gap-1',
          choiceTrackSurface,
          stackOnMobile ? 'flex flex-col sm:flex-row sm:rounded-full' : 'flex'
        )}
      >
        {options.map((option) => {
          const isSelected = value === option.value;
          return (
            <label
              key={option.value}
              className={cn(
                'flex-1 cursor-pointer py-2.5 px-3 text-center text-sm font-medium transition-all duration-200',
                stackOnMobile ? 'rounded-lg sm:rounded-full' : 'rounded-full',
                'focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2',
                isSelected ? choiceSelectedSurface : choiceUnselectedOnTrackSurface
              )}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                className="sr-only"
              />
              {option.label}
            </label>
          );
        })}
      </div>
    </div>
  );
}
